import { css } from 'styled-components';
import { PinCodeViewProps } from './models';
import { viewWrapper } from '../../styles';

export const PinCodeView = css<PinCodeViewProps>(({ theme }) => {
  return css`
    ${viewWrapper}

    > .pin-code-sent {
      font-weight: 500;
      font-size: 16px;
      line-height: 21px;
      margin-top: 44px;
      color: ${theme.colors.primaryDeepBlue};
      white-space: pre-line;
    }

    > .pin-code-footer {
      margin: 0;
    }

    > .verification-code-wrapper {
      margin-top: 16px;

      > .timing {
        margin-top: 20px;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        white-space: pre-line;
        color: ${theme.colors.primaryDeepBlue};

        @media only screen and ${theme.device.mobileXL} {
          margin-top: 25px;
        }
      }
    }
  `;
});
